<template>
<div id="dailySecMonRpt" class="content">
            <h4>{{ title }}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-12">
                    <form class="form" @submit.prevent="displayHandler">
                            <div class="form-group row">
                                <div class="col-sm-2">
                                    <label class="control-label" for="created_at">{{ label.start_date }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <input type="date" class="form-control" required id="start_date" name="new_start_date" v-model="reqCrit.start_date" >
                                </div>
                                <div class="col-sm-2">
                                    <label class="control-label" for="ended_at">{{ label.end_date }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <input type="date" class="form-control" required id="end_date" name="end_date" v-model="reqCrit.end_date" >
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-2">
                                    <label class="control-label" for="clockin_id">{{ label.clockin_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.clockin_id">
                                        <option v-for="(item, index) in reasons" :key="index" v-bind:value="{id : item.id, name: item.display_name}">{{ item.display_name }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-2">
                                    <label class="control-label" for="clockout_id">{{ label.clockout_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.clockout_id">
                                        <option v-for="(item, index) in reasons" :key="index" v-bind:value="{id : item.id, name: item.display_name}">{{ item.display_name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <span style="color: blue">Filter By </span>  
                                </div>
                                
                                
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.project_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.project_id" v-on:change="setProjectsSelection()">
                                        <option v-for="(item, index) in projects" :key="index" v-bind:value="{id: item.id, name: item.display_name}">{{ item.display_name }}</option>
                                    </select>
                                    <div>
                                        <span v-if="projectSelection != '' ">Selected:
                                            <ul style="list-style: none;" v-for="(item, index) in projectSelection" :key="index">
                                                <li><v-icon @click="delProjectsSelection(index)">delete</v-icon>{{ item.name }} </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row text-center">
                                <div v-if="loading" class="col-sm-11">                        
                                    <button type="submit" class="btn btn-default" disabled >DOWNLOAD</button>
                                </div>
                                <div  v-else class="col-sm-11">                        
                                    <button type="submit" class="btn btn-primary" >DOWNLOAD</button>
                                </div>
                            </div>
                    </form>
                </div>
            </div>
            <hr />
</div>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import XLSX from 'xlsx/xlsx';

import { formatUXDateTime, formatUX24DateTime, formatUXDate, formatUXTime, formatUX24Time } from '../common/toggle.js'

export default {
    data () {
        return {
            title: 'DAILY SECURITY MONITORING REPORT',

            label: {
                start_date: 'Records From',
                end_date: 'Records To',
                clockin_id: 'Clock In',
                clockout_id: 'Clock Out',
                project_id: 'Project',
            },
            reqCrit: {
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                clockin_id: '',
                clockout_id: '',
                project_id: '',
            },
            clockinSelection: [],
            clockoutSelection: [],
            projectSelection: [],
            projects: [],
            reasons: [],
            analysis: [],
            status: '',
            dialogEdit: false,
            dialogNew: false,
            errormsg: null,
            pagination: {'sortBy': 'clock_in_at', 'sortBy': 'clock_out_at',
                'descending': true, 'rowPerPage': -1},
            loading: false
        }
    },

    methods: {

        setProjectsSelection() {
            var projectSel = []

            if (this.reqCrit.project_id !== null) {
                projectSel.push(this.reqCrit.project_id)

                for (let i =0; i < projectSel.length; ++i) {
                    this.projectSelection.push(projectSel[i])
                }
            }

        },

        delProjectsSelection(i) {
            //document.getElementById("projectOption").selectedIndex = "-1"
            this.reqCrit.project_id = ''
            this.projectSelection.splice(i, 1)
            
        },

        retriveProjects() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/projects/list')
            .then(function (response) {
                vm.projects = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveReasons() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/reason/list')
            .then(function (response) {
                vm.reasons = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        objectToCSV(data) {
            const csvRows = []

            // get header

            console.log(data);
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            console.log(headers);
            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            
            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        displayHandler() {
            const vm = this;
            vm.loading = true;

            var projectList = [];

            for (let i = 0; i < this.projectSelection.length; ++i) {
                projectList.push(this.projectSelection[i].id)
            }

            var payload = {
                start_date: this.reqCrit.start_date,
                end_date: this.reqCrit.end_date,
                clockin_id: this.reqCrit.clockin_id.id,
                clockout_id: this.reqCrit.clockout_id.id,
                project_id: projectList
            }
            
            axios.post(this.$store.getters.rootAPI + '/reportdisplay/dailysecmon', payload)
                .then((res) => {
                console.log(res.data);
                vm.loading = false;
                if (res.data && res.status == 200) {
                    // const csvData = this.objectToCSV(res.data.rec);
                    // this.download(csvData);
                    
                    const ws = XLSX.utils.json_to_sheet(res.data.rec);
                    const wb = XLSX.utils.book_new();
                    console.log('wb', wb)
                    console.log('ws', ws)
                    XLSX.utils.book_append_sheet(wb, ws, 'Report');
                    XLSX.writeFile(wb, 'Daily Security Monitoring Report' + '.xlsx');
                } else {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    vm.loading = false;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                }
                })
                .catch((err) => {
                    
                    console.log(err);
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
            vm.loading = false;;
        },
    },    

    created() {
        this.retriveProjects();
        this.retriveReasons();
    }
}
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>


// WEBPACK FOOTER //
// src/components/report/DailySecMonRpt.vue